<template>
    <div :key="tableKey">
        <div v-if="loading">
            <loading></loading>
        </div>

        <div v-else>
            <b-alert variant="danger" :show="hasErrors">
                <span v-html="errorMessage"></span>
            </b-alert>
            <!-- filter -->
            <b-row v-if="!hasErrors" class="mb-3">
                <b-col md="6" class="my-1"> </b-col>
                <b-col md="6" class="my-1">
                    <b-form-group label-cols-sm="3" class="mb-0">
                        <b-input-group size="sm">
                            <b-form-input
                                v-model="filter"
                                placeholder="Entrer la valeur recherchée"
                            ></b-form-input>
                            <b-input-group-append>
                                <b-button
                                    :disabled="!filter"
                                    @click="filter = ''"
                                    >Effacer</b-button
                                >
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <!-- /filter -->

            <!-- Table -->
            <b-table
                responsive
                small
                :items="items"
                :fields="fields"
                :filter="filter"
                :per-page="perPage"
                :current-page="currentPage"
                primary-key="id"
                @filtered="onFiltered"
            >
                <template #cell(id)="data">
                    <delete-pending-point :point="data.item" />
                </template>
                <template #cell(comments.data)="row">
                    <div v-if="row.item.comments.data.length > 0">
                        <a
                            href="#"
                            title="Afficher la conversation"
                            @click="row.toggleDetails"
                        >
                            <i
                                class="fas fa-fw fa-comment-lines text-secondary"
                            ></i>
                        </a>
                    </div>
                </template>
                <template #cell(files.data)="row">
                    <div v-if="row.item.files.data.length > 0">
                        <a
                            href="#"
                            title="Afficher le fichier joint"
                            @click="row.toggleDetails"
                        >
                            <i
                                class="fas fa-fw fa-paperclip text-secondary"
                            ></i>
                        </a>
                    </div>
                </template>
                <template #cell(entry_date)="data">
                    <span>{{ data.item.entry_date | moment('D/M/Y') }}</span>
                </template>
                <template #cell(debit)="data">
                    <span> {{ Number(data.item.debit).toFixed(2) }}</span>
                </template>
                <template #cell(credit)="data">
                    <span> {{ Number(data.item.credit).toFixed(2) }}</span>
                </template>

                <template #row-details="row">
                    <chat :point="row.item" />
                </template>
            </b-table>
            <!-- /Table -->

            <!-- Pagination -->
            <b-row>
                <b-col md="3" class="my-1 text-center">
                    <b-pagination
                        v-if="totalRows > 0"
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        class="my-0"
                        size="sm"
                    ></b-pagination>
                </b-col>
                <b-col md="6" class="my-2">
                    <p class="text-center small pt-0">{{ legend }}</p>
                </b-col>
                <b-col md="3" class="my-1 text-right">
                    <b-dropdown
                        right
                        split
                        size="sm"
                        :text="perPage + ' éléments par page'"
                    >
                        <b-dropdown-item
                            v-for="pageOption in pageOptions"
                            :key="pageOption"
                            @click="setPerPage(pageOption)"
                        >
                            {{ pageOption }}
                        </b-dropdown-item>
                    </b-dropdown>
                </b-col>
            </b-row>
            <!-- /Pagination -->
        </div>
    </div>
</template>

<script>
import TableHandler from '../../../../common/mixins/TableHandler'
import Chat from './Chat'

export default {
    name: 'TableSolved',

    components: { Chat },

    mixins: [TableHandler],

    props: {
        client: Number,
    },

    data() {
        return {
            fields: [
                {
                    key: 'id',
                    label: '',
                    class: 'td-icon',
                },
                {
                    key: 'comments.data',
                    label: '',
                    class: 'td-icon',
                },
                {
                    key: 'files.data',
                    label: '',
                    class: 'td-icon',
                },
                {
                    key: 'entry_date',
                    label: 'Date',
                    class: 'td-sm text-center',
                    sortable: true,
                },
                {
                    key: 'account_code',
                    label: 'N° Compte',
                    class: 'td-sm',
                    sortable: true,
                },
                {
                    key: 'account_name',
                    label: 'Compte',
                    class: 'td-sm',
                    sortable: true,
                },
                {
                    key: 'document',
                    label: 'Pièce',
                    class: 'td-sm',
                    sortable: true,
                },
                {
                    key: 'description',
                    label: 'Libellé',
                    class: 'td-sm',
                    sortable: true,
                },
                {
                    key: 'debit',
                    label: 'Débit',
                    class: 'td-sm text-right',
                    sortable: true,
                },
                {
                    key: 'credit',
                    label: 'Crédit',
                    class: 'td-sm text-right',
                    sortable: true,
                },
                {
                    key: 'question',
                    label: 'Question',
                    class: 'td-sm td-question',
                    sortable: true,
                },
            ],
        }
    },

    async created() {
        this.filterable = false
        // this.$store.commit('browsing/SET_PAGE_NAME', 'pendingSolvedTable')
        await this.getItems()
    },

    methods: {
        async getItems() {
            try {
                this.loading = true
                const response = await axios.get(
                    `/clients/${this.client}/pendingPoints/solved`
                )
                this.items = response.data.data
                this.loading = false
            } catch (error) {
                // handle error
                console.log(error)
                this.handleErrors(error.response)
            }
        },

        updateCounters() {
            this.$store.dispatch('clientVM/getCounters', this.client)
        },
    },
}
</script>

<style scoped></style>
